import { useEffect } from "react";

const SITE = "https://selahandstonelegacy.com";

/**
 * Sets the document title and the <link rel="canonical"> tag per page.
 * Also toggles a robots meta tag for admin-style routes that should not be indexed.
 *
 * @param {Object} options
 * @param {string} options.title          - Full page title
 * @param {string} options.description    - Meta description
 * @param {string} options.path           - Canonical path (e.g. "/", "/support")
 * @param {boolean} [options.noindex]     - If true, adds noindex/nofollow
 */
export default function useSEO({ title, description, path, noindex = false }) {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE}${path || "/"}`);

    // Meta description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }

    // Robots
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute(
      "content",
      noindex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    );

    // og:url + og:title
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute("content", `${SITE}${path || "/"}`);

    if (title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement("meta");
        ogTitle.setAttribute("property", "og:title");
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute("content", title);
    }
  }, [title, description, path, noindex]);
}
